<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">自取卷資料</span>
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Collection id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="自取卷編號："
                  label-for="id"
                  label-cols-md="3"
                >
                  <div class="">
                    {{
                      newCollectionData.id
                        ? newCollectionData.voucher_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <!-- pick_up_date -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_pick_up_date"
                >
                  <b-form-group
                    label="自取卷日期："
                    label-for="pick_up_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newCollectionData.pick_up_date"
                      class="form-control"
                      :config="{
                        enableTime: true,
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d H:i',
                        dateFormat: 'Y-m-d H:i',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- invoice_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_invoice_id"
                >
                  <b-form-group
                    label="發票："
                    label-for="invoice_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="invoice_id"
                      v-model="newCollectionData.invoice_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="invoiceOptions"
                      :clearable="false"
                      label="invoice_number"
                      :reduce="(option) => option.id"
                      placeholder="選擇發票"
                      @input="onInvoiceChange"
                      :filter="invoiceSearch"
                    >
                      <template #option="{ invoice_number, project_name, quotation_number }">
                        {{ invoice_number }} {{ project_name }} {{ quotation_number }}
                      </template>
                      <template
                        #selected-option="{ invoice_number, project_name, quotation_number }"
                      >
                        {{ invoice_number }} {{ project_name }} {{ quotation_number }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_customer_id"
                >
                  <b-form-group
                    label="客戶："
                    label-for="customer_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="customer_id"
                      v-model="newCollectionData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerOptions"
                      label="name_cn"
                      :reduce="(option) => option.id"
                      placeholder="選擇客戶"
                      :filter="customerSearch"
                    >
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer name_cn-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_cn"
                >
                  <b-form-group
                    label="單據抬頭："
                    label-for="c_name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_name_cn"
                      v-model="newCollectionData.name_cn"
                      placeholder="輸入單據抬頭"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer name_en-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_en"
                >
                  <b-form-group
                    label="系統帳號名稱："
                    label-for="c_name_en"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_name_en"
                      v-model="newCollectionData.name"
                      placeholder="輸入系統帳號名稱"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
              <!-- customer phone-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_phone"
                >
                  <b-form-group
                    label="聯絡電話："
                    label-for="collection_items"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="customer_phone"
                      v-model="newCollectionData.phone"
                      placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_voucher_status_id"
                >
                  <b-form-group
                    label="狀態："
                    label-for="voucher_status_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="voucher_status_id"
                      v-model="newCollectionData.voucher_status_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="voucherStatusOptions"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇狀態"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 phone-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 phone-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";

export default {
  data() {
    return {
      required,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    hide() {
      this.$router.replace("/coupon/list");
    },
    onInvoiceChange() {
      this.newCollectionData.customer_id = null;
      this.newCollectionData.name_cn = null;
      this.newCollectionData.name = null;
      this.newCollectionData.phone = null; 
      var invoice_id = this.newCollectionData.invoice_id
      var invoice = this.invoiceOptions.filter(item => item.id == invoice_id)[0]
      var customer = this.customerOptions.filter(item => item.id == invoice.customer_id)[0]
      if (invoice) {
        this.newCollectionData.customer_id = invoice.customer_id;
        this.newCollectionData.name_cn = customer.name_cn
        this.newCollectionData.name = customer.name
        this.newCollectionData.phone = customer.phone
      }
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("collection/editCollection", this.newCollectionData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              this.$emit("refetech-data");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    customerSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.customer_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    invoiceSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return item.invoice_number.toLowerCase().includes(search.toLowerCase());
      });
      return returnOptions;
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    collectionData: {
      type: Object,
      required: true,
    },
    invoiceOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    voucherStatusOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newCollectionData = ref({ id: 0 });

    watch(
      () => props.collectionData,
      (newVal) => {
        newCollectionData.value = { ...newVal };
      }
    );

    watch(
      () => newCollectionData.value.customer_id,
      (newVal, oldVal) => {
        if (props.customerOptions && props.customerOptions.length > 0) {
          const customer = props.customerOptions.filter(
            (ele) => ele.id == newVal
          )[0];

          if (customer) {
            newCollectionData.value.name_cn = customer.name_cn;
            newCollectionData.value.name = customer.name;
            newCollectionData.value.phone = customer.phone;
          }
        }
      }
    );

    const resetCollectionsData = () => {
      newCollectionData.value = JSON.parse(
        JSON.stringify({
          id: 0,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetCollectionsData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newCollectionData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
